<template>
	<VueSlickCarousel v-bind="settings" @lazyLoad="lazyLoad" @afterChange="lazyLoad" ref="slider">
		<slot></slot>
	</VueSlickCarousel>
</template>

<script>
	import VueSlickCarousel from 'vue-slick-carousel';

	export default {
		props: [
			'slidesToShow',
			'slidesToShowMobile',
			'slidesToShowMedium',
			'slidesToShowSmall',
			'slidesToScroll',
			'showDotsMobile',
			'showDotsTablet',
			'autoplay',
			'autoplaySpeed',
			'pauseOnHover',
			'dots',
			'arrows',
			'infinite',
			'speed',
			'cssEase',
			'type'
		],

		components: {
			VueSlickCarousel
		},

		data() {

			const reviewsCarousel = this.type === 'carousel';

			return {
				settings: {
					autoplay: this.autoplay ?? false,
					cssEase: this.cssEase,
					autoplaySpeed: this.autoplaySpeed,
					pauseOnHover: this.pauseOnHover ?? true,
					slidesToShow: this.slidesToShow ?? 3,
					slidesToScroll: this.slidesToScroll ?? 1,
					dots: this.dots ?? false,
					arrows: this.arrows ?? true,
					infinite: this.infinite ?? false,
					waitForAnimate: false,
					swipeToSlide: true,
					draggable: false,
					touchThreshold: 10,
					speed: this.speed ? parseInt(this.speed) : 500,
					// lazyLoad: 'progressive',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								dots: this.showDotsTablet ?? false,
							}
						},
						{
							breakpoint: 960,
							settings: {
								slidesToShow: this.slidesToShowMedium ?? 2.1,
								slidesToScroll: this.slidesToShowMedium ?? 1,
								dots: this.showDotsTablet ?? false,
								arrows: true,
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: this.slidesToShowSmall ?? 2.1,
								dots: this.showDotsMobile ?? false,
								arrows: false,
							}
						},
						{
							breakpoint: 500,
							settings: {
								slidesToShow: this.slidesToShowMobile ?? 1.1,
								slidesToScroll: 1,
								dots: this.showDotsMobile ?? false,
								arrows: false,
								speed: 300,
							}
						},
						{
							breakpoint: 340,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								dots: this.showDotsMobile ?? false,
								arrows: false,
							}
						},
					]
				}
			}
		},

		methods: {
			loadThumbnail(thumbnail) {
				if (thumbnail.style.backgroundImage || thumbnail.dataset.loading) return;

				thumbnail.dataset.loading = 'true';

				const image = new Image();

				image.onload = () => {
					thumbnail.style.backgroundImage = `url('${thumbnail.dataset.thumb}')`;

					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							thumbnail.classList.add('thumbnail-loaded');
						});
					});
				};

				image.onerror = () => {
					delete thumbnail.dataset.loading;
				};

				image.src = thumbnail.dataset.thumb;
			},

			loadImages(el) {
				const images = el.querySelectorAll('img[data-src]:not([src])');
				const videos = el.querySelectorAll('video[data-src]:not([src])');
				const bgImages = el.querySelectorAll('.bg-container[data-src]:not(.loaded)');

				images.forEach(img => window.imgLazyload(img));
				videos.forEach(video => window.videoLazyload(video));
				bgImages.forEach(bg => window.bgLazyLoad(bg));

				el.querySelectorAll('.slick-slide.slick-active .thumbnail[data-thumb]').forEach(thumbnail => {
					this.loadThumbnail(thumbnail);
				});
			},
		
			lazyLoad() {
				this.$nextTick(() => {
					if (!this.$refs.slider) return;

					this.loadImages(this.$refs.slider.$el);

					if (typeof window.initVideoSlides === 'function') {
						window.initVideoSlides();
					}
				});
			}
		},

		mounted() {
			const slider = this.$el;
			const sliderContainer = slider.parentNode;
			const noSliderMobile = sliderContainer.querySelector('.no-slider-mobile');

			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) return;

					const el = window.getComputedStyle(slider).display == 'none' && noSliderMobile ? noSliderMobile : this.$refs.slider.$el;

					this.loadImages(el);
				
					observer.unobserve(sliderContainer);
				});
			}, {
				rootMargin: '300px'
			});

			observer.observe(sliderContainer);

			let resizeTimeout;

			window.addEventListener('resize', () => {
				if(getComputedStyle(sliderContainer.querySelector('.slick-slider')).display && noSliderMobile) {
					clearTimeout(resizeTimeout);

					resizeTimeout = setTimeout(() => {
						this.loadImages(noSliderMobile);
					}, 300);
				}
			});

			// setTimeout(() => {
			// 	this.$el.querySelectorAll('button').forEach(el => {
			// 		const url = el.dataset.thumb;
			// 		if (url) {
			// 			el.style.backgroundImage = `url('${url}')`;
			// 		}
			// 	});
			// }, 1000);
		}
	}
</script>